import {UserLevel} from '@netx/core-user-next/constants';

export const ASSET_DOWNLOAD_MINUMUM_USER_LEVEL = UserLevel.CONSUMER;

export enum OrganizeAssetsAction {
	ADD = 'add',
	MOVE = 'move',
	REMOVE = 'remove',
}

export enum CategoryOrder {
	/** provided order */
	MANUAL = 0,
	/** normal */
	ALPHABETICAL_ASC = 1,
	/** reversed */
	ALPHABETICAL_DESC = 2,
}

export enum CategoryPref {
	KEEP_ALPHABETICAL = 'category.keepListAlphabetical',
}
